import type { FrameProps } from "@/components/shapes/shared/frame-props";
import { useT } from "@/i18n";
import { framesEventMessages } from "@/i18n/messages/frames-event";
import { cardPaint } from "../shared/card-paint";
import { FrameEmptyState } from "../shared/frame-empty-state";
import { ObjectFrame } from "../shared/object-frame";
import { eventFields, hasEvent } from "./event-content";
import { EventFace } from "./event-face";

/** An event: its card, larger, with the full detail. */
export function EventFrame({ id, data }: FrameProps) {
  const t = useT(framesEventMessages);
  const fields = eventFields(data.content ?? {});
  return (
    <ObjectFrame id={id} paint={cardPaint(data)} testId="event-frame">
      {hasEvent(fields) ? (
        <EventFace
          fields={fields}
          density="regular"
          opened
          testIdPrefix="event-frame"
        />
      ) : (
        <FrameEmptyState
          frameId={id}
          status={data.status}
          testId="event-frame-empty"
        >
          {t("noUpcomingEvent")}
        </FrameEmptyState>
      )}
    </ObjectFrame>
  );
}
